import React from "react";
import { Row, Col, Button, MessageBanner } from "@folio/stripes/components";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { useItemEditor } from "../../hooks/title/useItemEditor";
import { useContentRows } from "../../utils/toContentRows";
import { FormSectionModal } from "./FormSectionModal";
import { useFieldArrayErrors } from "../../hooks/useFieldArrayErrors";
import { EntityRowList } from "./EntityRowList";
import css from "./FormModal.module.css";
var TitlePublicationPlacesForm = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useFormContext(), control = _a.control, getValues = _a.getValues;
    var errorMessages = useFieldArrayErrors("publicationPlaces");
    var _b = useFieldArray({ control: control, name: "publicationPlaces" }), placeFields = _b.fields, appendPlace = _b.append, updatePlace = _b.update, removePlace = _b.remove;
    var _c = useItemEditor({
        appendItem: appendPlace,
        updateItem: updatePlace,
        createEmpty: function () { return ({ city: "" }); },
    }), isOpen = _c.isOpen, isEditing = _c.isEditing, draft = _c.draft, setDraft = _c.setDraft, openEditor = _c.openEditor, closeEditor = _c.closeEditor, saveItem = _c.saveItem;
    var contentData = useContentRows(placeFields);
    var columns = [
        {
            name: formatMessage({
                id: "ui-br-agency.title.publicationPlaces.city.label",
            }),
            cellRenderer: function (row) { return row.city || "-"; },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 }, placeFields.length > 0 ? (React.createElement(EntityRowList, { data: contentData, columns: columns, onEdit: function (row) {
                    return openEditor(getValues("publicationPlaces.".concat(row._index)), row._index);
                }, onDelete: function (row) { return removePlace(row._index); }, canDelete: function () { return placeFields.length > 1; } })) : (React.createElement("div", { className: css.emptyState },
                React.createElement(FormattedMessage, { id: "ui-br-agency.title.places.empty" }))))),
        errorMessages.length > 0 && (React.createElement(Row, { "data-error-field": "publicationPlaces" },
            React.createElement(Col, { xs: 12 },
                React.createElement(MessageBanner, { type: "error", className: css.tableErrorBanner }, errorMessages.map(function (msg) { return (React.createElement("div", { key: msg }, msg)); }))))),
        React.createElement(FormSectionModal, { open: isOpen, isEditing: isEditing, draft: draft, onDraftChange: setDraft, onSave: saveItem, onClose: closeEditor, addLabelId: "ui-br-agency.title.places.form.add.title", editLabelId: "ui-br-agency.title.places.form.edit.title", fields: [
                {
                    key: "city",
                    labelId: "ui-br-agency.title.place.city.label",
                    type: "text",
                    required: true,
                    colSpan: 12,
                },
            ], validate: function (d) { var _a; return !!((_a = d.city) === null || _a === void 0 ? void 0 : _a.trim()); } }),
        React.createElement(Row, { className: css.actions },
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return openEditor(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.form.add.place" }))))));
};
export default TitlePublicationPlacesForm;
